module.exports = __webpack_public_path__ + "assets/xinzi.6f36acd4.svg";